import { DateDisplay, ProfileDisplay } from "../../../components";
import { FixedCell } from "../../../components/tables/StandardTable";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import { ThemedSpan } from "../../../components/utilities";
import useOpenDocument from "../../../hooks/useOpenDocument";

const AdviceRegisterTableRow = ({ data, index, style }) => {
    const { height } = style;

    const { openDocument, isFetching: isOpening } = useOpenDocument();

    if (data[index] == null) {
        return <TableLoadingRow style={{ height }} />
    }

    const {
        sentDate,
        compliantDate,
        reportName,
        reportTypeDescription,
        masterAccountId,
        masterAccountReference,
        masterAccountName,
        documentId,
        authorId,
        author,
        adviserId,
        adviser,
        complianceUserId,
        complianceUser,
        rejectCount,
        compliantStatusDescription,
        adminStatusDescription
    } = data[index];

    const handleOpenDocument = () => {
        if (isOpening)
            return;

        openDocument(documentId);
    }

    return <tr style={{ height }} className="align-middle">
        <FixedCell className="text-truncate">
            <ProfileDisplay userId={adviserId} userDisplayName={adviser} />
        </FixedCell>
        <FixedCell className="text-truncate">
            <a href={`/client/${masterAccountId}`}>
                {masterAccountReference} - {masterAccountName}
            </a>
        </FixedCell>
        <FixedCell className="text-truncate">
            <p className="m-0 lh-1 text-truncate">
                <span>
                    <button className="anchor" onClick={handleOpenDocument}>{reportName}</button>
                    <br />
                    <ThemedSpan variant="muted" className="fs-smallest">
                        {reportTypeDescription}
                    </ThemedSpan>
                </span>
            </p>
        </FixedCell>
        <FixedCell className="text-truncate">
            <ProfileDisplay userId={authorId} userDisplayName={author} />
        </FixedCell>
        <FixedCell className="text-truncate">
            <ProfileDisplay userId={complianceUserId} userDisplayName={complianceUser} />
        </FixedCell>
        <FixedCell className="text-truncate">
            {rejectCount}
        </FixedCell>
        <FixedCell className="text-truncate">
            {compliantDate == null
                ? "Not Compliant"
                : <p className="m-0 lh-1 text-truncate">
                    <span>
                        {compliantStatusDescription}
                        <br />
                        <DateDisplay variant="muted" className="fs-smaller">
                            {compliantDate}
                        </DateDisplay>
                    </span>
                </p>}
        </FixedCell>
        <FixedCell className="text-truncate">
            {sentDate == null ? "Not Sent" : <DateDisplay>{sentDate}</DateDisplay>}
        </FixedCell>
        <FixedCell className="text-truncate">
            {adminStatusDescription}
        </FixedCell>
    </tr>
}

export default AdviceRegisterTableRow;